import { ReduxAction } from 'types/redux';
import * as summaryAction from '../../actions/dashboard/actionTypes';

const initState = {
    isRequesting: false,
    data: [],
    users: null,
    briks: []
};

export function dashboard(state = initState, actions: ReduxAction){
  const { type, payload } = actions;
  switch (type) {
    case summaryAction.actionTypes.GET_BRIK_SUMMARY:
      return {
        ...state,
        isRequesting: true,
        briks: []
      };
    case summaryAction.actionTypes.GET_BRIK_SUMMARY_SUCCESS:
      return {
        ...state,
        isRequesting: false,
        briks: payload
      };
    case summaryAction.actionTypes.GET_BRIK_SUMMARY_FAIL:
        return {
          ...state,
          isRequesting: false,
          briks: []
        };

    case summaryAction.actionTypes.GET_GRAPH_SUMMARY:
      return {
        ...state,
        isRequesting: true
      };
    case summaryAction.actionTypes.GET_GRAPH_SUMMARY_SUCCESS:
      return {
        ...state,
        isRequesting: false,
        data: payload
      };
    case summaryAction.actionTypes.GET_GRAPH_SUMMARY_FAIL:
        return {
          ...state,
          isRequesting: false
        };

      case summaryAction.actionTypes.GET_USER_SUMMARY:
        return {
          ...state,
          isRequesting: true
        };
      case summaryAction.actionTypes.GET_USER_SUMMARY_SUCCESS:
        return {
          ...state,
          isRequesting: false,
          users: payload
        };
      case summaryAction.actionTypes.GET_USER_SUMMARY_FAIL:
          return {
            ...state,
            isRequesting: false
          };
    default:
      return state;
  }
};
